import styled from 'styled-components';
import { rem } from '@/styles/theme';

export const Container = styled.div`
  width: 100%;
  margin: ${rem(8)} auto ${rem(18)};
  overflow: hidden;
  height: 100%;
`;

export const Wrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  .swiper {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: visible;
  }
  .swiper-slide {
    overflow: hidden;
    border-radius: ${rem(16)};
    width: 100%;
    height: 100%;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  aspect-ratio: 1 / 0.42528735632;
  cursor: pointer;
  width: 100%;
  height: 100%;
  border-radius: ${rem(16)};
  overflow: hidden;
`;

export const Image = styled.img`
  object-fit: cover ;
  width: 100%;
`
